export enum SecondarySectionsGroupBlock {
  Root = 'SecondarySectionsGroup',
}
